import React from "react"

export default function ProductCard(props) {
    return (
        <div className="flex flex-col rounded-lg shadow-lg overflow-hidden mx-4">
            <div className="flex flex-shrink-0 justify-center items-center">
                <img className="flex h-full w-full object-cover" src={props.img} alt={props.alt} />
            </div>
        </div>
    )
}
